import React, { useState, useContext } from "react";
import "./EmployeeForm.css";
import { Usercontext } from "../../App";
import { useNavigate } from "react-router-dom";

const AdminProduct = () => {
  const { title, setTitle } = useContext(Usercontext);
  const [showMarriageDate, setShowMarriageDate] = useState(false);
  const [showDependent, setShowDependent] = useState(false);
  const [showEdcation, setShowEducation] = useState(false);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: title?.firstName || "",
    lastName: title?.lastName || "",
    empId: title?.empId || "",
    middleName: title?.middleName || "",
    email: title?.email || "",
    blood: title?.blood || "",
    department: title?.department || "",
    location: title?.location || "",
    designation: title?.designation || "",
    employmentType: title?.employmentType || "",
    employeeStatus: title?.employeeStatus || "",
    sourceOfHire: title?.sourceOfHire || "",
    dateOfJoining: title?.dateOfJoining || "",
    currentExperience: title?.currentExperience || "",
    totalExperience: title?.totalExperience || "",
    primaryReportingManager: title?.primaryReportingManager || "",
    secondaryReportingManager: title?.secondaryReportingManager || "",
    dateOfBirth: title?.dateOfBirth || "",
    age: title?.age || "",
    gender: title?.gender || "",
    maritalStatus: title?.maritalStatus || "",
    aboutMe: title?.aboutMe || "",
    UAN: title?.UAN || "",
    PAN: title?.PAN || "",
    Aadhaar: title?.Aadhaar || "",
    workPhoneNumber: title?.workPhoneNumber || "",
    extension: title?.extension || "",
    seatingLocation: title?.seatingLocation || "",
    personalEmailAddress: title?.personalEmailAddress || "",
    presentAddress: title?.presentAddress || "",
    dateOfExit: title?.dateOfExit || "",
    companyName: title?.companyName || "",
    jobTitle: title?.jobTitle || "",
    fromDate: title?.fromDate || "",
    toDate: title?.toDate || "",
    jobDescription: title?.jobDescription || "",
    instituteName: title?.instituteName || "",
    degreeDiploma: title?.degreeDiploma || "",
    specialization: title?.specialization || "",
    dateOfCompletion: title?.dateOfCompletion || "",
    nameOfParent: title?.nameOfParent || "",
    relationship: title?.relationship || "",
    parentDateOfBirth: title?.parentDateOfBirth || "",
    image: title?.image || "",
    parentno: title?.parentno || "",
    marriageDate: title?.marriageDate || "",
    nameOfParent2: title?.nameOfParent2 || "",
    relationship2: title?.relationship2 || "",
    parentDateOfBirth2: title?.parentDateOfBirth2 || "",
    parentno2: title?.parentno2 || "",
    instituteName2: title?.instituteName2 || "",
    degreeDiploma2: title?.degreeDiploma2 || "",
    specialization2: title?.specialization2 || "",
    dateOfCompletion2: title?.dateOfCompletion2 || "",
    instituteName3: title?.instituteName3 || "",
    degreeDiploma3: title?.degreeDiploma3 || "",
    specialization3: title?.specialization3 || "",
    dateOfCompletion3: title?.dateOfCompletion3 || "",

  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "maritalStatus" && value === "Married") {
      setShowMarriageDate(true);
    } else if (name === "maritalStatus" && value === "Single") {
      setShowMarriageDate(false);
    }

    if (name === "dateOfBirth") {
      const dob = new Date(value);
      const currentDate = new Date();
      const age = currentDate.getFullYear() - dob.getFullYear();
      const month = currentDate.getMonth() - dob.getMonth();

      if (month < 0 || (month === 0 && currentDate.getDate() < dob.getDate())) {
        setFormData((prevData) => ({
          ...prevData,
          dateOfBirth: value,
          age: age - 1,
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          dateOfBirth: value,
          age: age,
        }));
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleFileChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      file: e.target.files[0],
    }));
  };

  return (
    <>
      <div className="app-container">
        <h3>Employee Details View</h3>
        <button type="button" className="btn btn-secondary" onClick={() => navigate("/employeedata")}>
          Close
        </button>
        <form className="upload-form">
          {" "}
          <br />
          <br />
          <div className="form-container">
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="file">Profile Picture <span className="required">*</span></label>
                  {
                    formData.image ? <img style={{width: "200px", height: "200px"}} src={formData.image} alt="profile image"/> : <p className="form-label">Profile picture not uploaded</p>
                  }
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="empId">
                    Employee ID <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="empId"
                    name="empId"
                    value={formData.empId}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                    readOnly
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="firstName">
                    First Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    placeholder="Enter First Name"
                    pattern="[A-Za-z]+"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                    readOnly
                  />
                </div>
              </div>
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="lastName">
                    Last Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    placeholder="Enter Last Name"
                    pattern="[A-Za-z]+"
                    readOnly
                    value={formData.lastName}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="middleName">Middle Name</label>
                  <input
                    type="text"
                    id="middleName"
                    name="middleName"
                    pattern="[A-Za-z]+"
                    readOnly
                    value={formData.middleName}
                    onChange={handleInputChange}
                    placeholder="Enter Middle Name"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="email">Email <span className="required">*</span></label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter Email"
                    className="form-control"
                    readOnly
                    required
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="blood">Blood Group <span className="required">*</span></label>
                  <input
                    type="text"
                    id="blood"
                    name="blood"
                    value={formData.blood}
                    readOnly
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="location">Location</label>
                  <input
                    type="text"
                    id="location"
                    name="location"
                    pattern="[A-Za-z]+"
                    readOnly
                    value={formData.location}
                    onChange={handleInputChange}
                    placeholder="Enter Location"
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="department">
                    Department <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="department"
                    name="department"
                    readOnly
                    value={formData.department}
                    onChange={handleInputChange}
                    placeholder="Enter Department"
                    className="form-control"
                  />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="designation">
                    Designation <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="designation"
                    name="designation"
                    readOnly
                    value={formData.designation}
                    onChange={handleInputChange}
                    placeholder="Enter Designation"
                    className="form-control"
                  />
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="employmentType">Employment Type <span className="required">*</span></label>
                  <select
                    id="employmentType"
                    name="employmentType"
                    value={formData.employmentType}
                    disabled
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  >
                    <option value="">Select Employment Type</option>
                    <option value="Full-time">Full-time</option>
                    <option value="Part-time">Part-time</option>
                    <option value="Interns">Interns</option>
                  </select>
                </div>
              </div>
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="employeeStatus">Employee Status <span className="required">*</span></label>
                  <select
                    id="employeeStatus"
                    name="employeeStatus"
                    value={formData.employeeStatus}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                    disabled

                  >
                    <option value="">Select Employee Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Terminated">Terminated</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="sourceOfHire">Source of Hire</label>
                  <select
                    id="sourceOfHire"
                    name="sourceOfHire"
                    value={formData.sourceOfHire}
                    onChange={handleInputChange}
                    readOnly
                    disabled
                    className="form-control"
                  >
                    <option value="">Select Source of Hire</option>
                    <option value="Walk-in Drive">Walk-in Drive</option>
                    <option value="Employee Referrals">Employee Referrals</option>
                    <option value="Past Employees">Past Employees</option>
                  </select>
                </div>
              </div>
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="dateOfJoining">Date of Joining <span className="required">*</span></label>
                  <input
                    type="date"
                    id="dateOfJoining"
                    name="dateOfJoining"
                    value={
                      formData.dateOfJoining
                        ? new Date(formData.dateOfJoining)
                          .toISOString()
                          .split("T")[0]
                        : ""
                    }
                    readOnly
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="currentExperience">Current Experience (in years)</label>
                  <input
                    type="text"
                    id="currentExperience"
                    name="currentExperience"
                    readOnly
                    value={formData.currentExperience}
                    onChange={handleInputChange}
                    placeholder="Enter Current Experience"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="totalExperience">Total Experience (in years)</label>
                  <input
                    type="text"
                    id="totalExperience"
                    name="totalExperience"
                    readOnly
                    value={formData.totalExperience}
                    onChange={handleInputChange}
                    placeholder="Enter Total Experience"
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <br /><br />
            <h3>
              <center>Hierarchy information</center>
            </h3>

            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="primaryReportingManager">
                    Primary Reporting Manager <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="primaryReportingManager"
                    name="primaryReportingManager"
                    pattern="[A-Za-z]+"
                    readOnly
                    value={formData.primaryReportingManager}
                    onChange={handleInputChange}
                    placeholder="Enter primary Reporting Manager"
                    className="form-control"
                  />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="secondaryReportingManager">
                    Secondary Reporting Manager
                  </label>
                  <input
                    type="text"
                    id="secondaryReportingManager"
                    name="secondaryReportingManager"
                    pattern="[A-Za-z]+"
                    readOnly
                    value={formData.secondaryReportingManager}
                    onChange={handleInputChange}
                    placeholder="Secondary Reporting Manager"
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <br />
            <h3>
              <center>Personal Information</center>
            </h3>
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="dateOfBirth">
                    Date of Birth <span className="required">*</span>
                  </label>
                  <input
                    type="date"
                    id="dateOfBirth"
                    name="dateOfBirth"
                    readOnly
                    value={
                      formData.dateOfBirth
                        ? new Date(formData.dateOfBirth)
                          .toISOString()
                          .split("T")[0]
                        : ""
                    }
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="age">
                    Age <span className="required">*</span>
                  </label>
                  <input
                    type="number"
                    id="age"
                    name="age"
                    readOnly
                    value={formData.age}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                    disabled
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="gender">
                    Gender <span className="required">*</span>
                  </label>
                  <select
                    id="gender"
                    name="gender"
                    disabled
                    value={formData.gender}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>

                    <option value="Female">Female</option>
                    <option value="Transgender">Transgender</option>
                  </select>
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="maritalStatus">
                    Marital Status <span className="required">*</span>
                  </label>
                  <select
                    id="maritalStatus"
                    name="maritalStatus"
                    disabled
                    value={formData.maritalStatus}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  >
                    <option value="">Select Marital Status</option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                  </select>
                </div>
              </div>

              {showMarriageDate && (
                <div className="col">
                  <div className="form-group">
                    <label className="form-label" htmlFor="marriageDate">
                      Marriage Date <span className="required">*</span>
                    </label>
                    <input
                      type="date"
                      id="marriageDate"
                      name="marriageDate"
                      readOnly
                      value={formData.marriageDate}
                      onChange={handleInputChange}
                      className="form-control"
                      required
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="aboutMe">About Me</label>
                  <textarea
                    id="aboutMe"
                    name="aboutMe"
                    readOnly
                    value={formData.aboutMe}
                    onChange={handleInputChange}
                    rows={3}
                    className="form-control"
                  />
                </div>
              </div>
            </div><h3>
              <center>Identify Information</center>
            </h3>
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="UAN">
                    UAN <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="UAN"
                    name="UAN"
                    readOnly
                    required
                    pattern="\d{12}"
                    maxLength="12"
                    className="form-control"
                    value={formData.UAN}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="PAN">
                    PAN <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="PAN"
                    name="PAN"
                    readOnly
                    required
                    maxLength="10"
                    className="form-control"
                    value={formData.PAN}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>

            {/* Aadhaar & Work Phone Number */}
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="Aadhaar">
                    Aadhaar <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="Aadhaar"
                    name="Aadhaar"
                    pattern="\d{12}"
                    maxLength="12"
                    readOnly
                    required
                    className="form-control"
                    value={formData.Aadhaar}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="workPhoneNumber">
                    Work Phone Number <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="workPhoneNumber"
                    name="workPhoneNumber"
                    pattern="\d{10}"
                    maxLength="10"
                    readOnly
                    required
                    className="form-control"
                    value={formData.workPhoneNumber}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>

            {/* Extension & Seating Location */}
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="extension">Extension</label>
                  <input
                    type="text"
                    id="extension"
                    readOnly
                    name="extension"
                    className="form-control"
                    value={formData.extension}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="seatingLocation">Seating Location</label>
                  <input
                    type="number"
                    id="seatingLocation"
                    name="seatingLocation"
                    readOnly
                    className="form-control"
                    value={formData.seatingLocation}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>

            {/* Personal Email Address & Present Address */}
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="personalEmailAddress">
                    Personal Email Address <span className="required">*</span>
                  </label>
                  <input
                    type="email"
                    id="personalEmailAddress"
                    name="personalEmailAddress"
                    required
                    readOnly
                    className="form-control"
                    value={formData.personalEmailAddress}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="presentAddress">
                    Present Address <span className="required">*</span>
                  </label>
                  <textarea
                    id="presentAddress"
                    name="presentAddress"
                    required
                    rows="3"
                    readOnly
                    className="form-control"
                    value={formData.presentAddress}
                    onChange={handleInputChange}
                  ></textarea>
                </div>
              </div>
            </div>
            <br /> <br />
            <h3>
              <center> Work Experience</center>
            </h3>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label" htmlFor="companyName">Company Name</label>
                  <input
                    type="text"
                    id="companyName"
                    name="companyName"
                    readOnly
                    pattern="[A-Za-z]+"
                    value={formData.companyName}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label" htmlFor="jobTitle">Job Title</label>
                  <input
                    type="text"
                    id="jobTitle"
                    name="jobTitle"
                    readOnly
                    pattern="[A-Za-z]+"
                    value={formData.jobTitle}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            {/* From Date and To Date */}
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label" htmlFor="fromDate">From Date</label>
                  <input
                    type="date"
                    id="fromDate"
                    name="fromDate"
                    readOnly
                    value={formData.fromDate}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label" htmlFor="toDate">To Date</label>
                  <input
                    type="date"
                    id="toDate"
                    name="toDate"
                    readOnly
                    value={formData.toDate}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            {/* Job Description */}
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label className="form-label" htmlFor="jobDescription">Job Description</label>
                  <textarea
                    id="jobDescription"
                    name="jobDescription"
                    rows="3"
                    readOnly
                    pattern="[A-Za-z]+"
                    value={formData.jobDescription}
                    onChange={handleInputChange}
                    className="form-control"
                  ></textarea>
                </div>
              </div>
            </div>
            <br /> <br />
            <h3>
              <center> Education Details</center>
            </h3>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label" htmlFor="instituteName">
                    Institute Name <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="text"
                    id="instituteName"
                    name="instituteName"
                    readOnly
                    value={formData.instituteName}
                    pattern="[A-Za-z]+"
                    required
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label" htmlFor="degreeDiploma">
                    Degree/Diploma <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="text"
                    id="degreeDiploma"
                    name="degreeDiploma"
                    readOnly
                    pattern="[A-Za-z]+"
                    required
                    value={formData.degreeDiploma}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            {/* Specialization and Date of Completion */}
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label" htmlFor="specialization">
                    Specialization <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="text"
                    id="specialization"
                    name="specialization"
                    pattern="[A-Za-z]+"
                    required
                    readOnly
                    value={formData.specialization}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label" htmlFor="dateOfCompletion">
                    Date of Completion <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="date"
                    id="dateOfCompletion"
                    name="dateOfCompletion"
                    readOnly
                    value={formData.dateOfCompletion}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            {/* Add Education Button */}
            {/* <button
              type="button"
              onClick={handleAddEducation}
              className="btn btn-primary"
            >
              {showDependent ? 'Hide Education' : 'Add Education'}
            </button> */}
            <br />
            <br />

            {/* Show dependent education form if showDependent is true */}
            {showEdcation && (
              <div>
                {/* Second Education Form */}
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="instituteName2">
                        Institute Name <span style={{ color: 'red' }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="instituteName2"
                        name="instituteName2"
                        readOnly
                        value={formData.instituteName2}
                        pattern="[A-Za-z]+"
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="degreeDiploma2">
                        Degree/Diploma <span style={{ color: 'red' }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="degreeDiploma2"
                        name="degreeDiploma2"
                        pattern="[A-Za-z]+"
                        readOnly
                        value={formData.degreeDiploma2}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="specialization2">
                        Specialization <span style={{ color: 'red' }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="specialization2"
                        readOnly
                        name="specialization2"
                        value={formData.specialization2}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="dateOfCompletion2">
                        Date of Completion <span style={{ color: 'red' }}>*</span>
                      </label>
                      <input
                        type="date"
                        id="dateOfCompletion2"
                        name="dateOfCompletion2"
                        readOnly
                        value={formData.dateOfCompletion2}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>

                <br />
                <br />

                {/* Third Education Form */}
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="instituteName3">
                        Institute Name <span style={{ color: 'red' }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="instituteName3"
                        name="instituteName3"
                        readOnly
                        value={formData.instituteName3}
                        pattern="[A-Za-z]+"
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="degreeDiploma3">
                        Degree/Diploma <span style={{ color: 'red' }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="degreeDiploma3"
                        name="degreeDiploma3"
                        pattern="[A-Za-z]+"
                        readOnly
                        value={formData.degreeDiploma3}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="specialization3">
                        Specialization <span style={{ color: 'red' }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="specialization3"
                        name="specialization3"
                        value={formData.specialization3}
                        onChange={handleInputChange}
                        readOnly
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="dateOfCompletion3">
                        Date of Completion <span style={{ color: 'red' }}>*</span>
                      </label>
                      <input
                        type="date"
                        id="dateOfCompletion3"
                        name="dateOfCompletion3"
                        readOnly
                        value={formData.dateOfCompletion3}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            <br /> <br />
            <h3>
              <center>Dependent Details</center>
            </h3>
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="nameOfParent">Name of Dependent <span className="required">*</span></label>
                  <input
                    type="text"
                    id="nameOfParent"
                    name="nameOfParent"
                    className="form-control"
                    pattern="[A-Za-z]+"
                    readOnly
                    value={formData.nameOfParent}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter Dependent's Name"
                  />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="relationship">Relationship <span className="required">*</span></label>
                  <select
                    id="relationship"
                    name="relationship"
                    className="form-control"
                    disabled
                    value={formData.relationship}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Relationship</option>
                    <option value="father">Father</option>
                    <option value="mother">Mother</option>
                    <option value="guardian">Guardian</option>
                    <option value="siblings">Siblings</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="parentDateOfBirth">Dependent's Date of Birth</label>
                  <input
                    type="date"
                    id="parentDateOfBirth"
                    name="parentDateOfBirth"
                    className="form-control"
                    readOnly
                    value={formData.parentDateOfBirth}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label className="form-label" htmlFor="parentno">Dependent's No</label>
                  <input
                    type="text"
                    id="parentno"
                    name="parentno"
                    className="form-control"
                    pattern="\d{10}"
                    maxLength="10"
                    readOnly
                    value={formData.parentno}
                    onChange={handleInputChange}
                    placeholder="Enter Dependent's No"
                  />
                </div>
              </div>
            </div>
            {/* <button
              type="button"
              className="btn btn-primary"
              onClick={handleAddDependent}
            >
              {showDependent ? "Hide Dependent" : "Add Dependent"}
            </button> */}
            {/* Additional Dependent Form (hidden initially) */}
            {showDependent && (
              <div id="additionalDependentForm">
                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <label className="form-label" htmlFor="nameOfParent2">Name of Dependent <span className="required">*</span></label>
                      <input
                        type="text"
                        id="nameOfParent2"
                        name="nameOfParent2"
                        className="form-control"
                        readOnly
                        value={formData.nameOfParent2}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter Dependent's Name"
                      />
                    </div>
                  </div>

                  <div className="col">
                    <div className="form-group">
                      <label className="form-label" htmlFor="relationship2">Relationship <span className="required">*</span></label>
                      <select
                        id="relationship2"
                        name="relationship2"
                        className="form-control"
                        readOnly
                        value={formData.relationship2}
                        onChange={handleInputChange}
                      >
                        <option value="">Select Relationship</option>
                        <option value="father">Father</option>
                        <option value="mother">Mother</option>
                        <option value="guardian">Guardian</option>
                        <option value="siblings">Siblings</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <label className="form-label" htmlFor="parentDateOfBirth2">Dependent's Date of Birth</label>
                      <input
                        type="date"
                        id="parentDateOfBirth2"
                        name="parentDateOfBirth2"
                        className="form-control"
                        readOnly
                        value={formData.parentDateOfBirth2}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="col">
                    <div className="form-group">
                      <label className="form-label" htmlFor="parentno2">Dependent's No</label>
                      <input
                        type="text"
                        id="parentno2"
                        name="parentno2"
                        className="form-control"
                        readOnly
                        value={formData.parentno2}
                        onChange={handleInputChange}
                        placeholder="Enter Dependent's No"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </form >
      </div >
    </>
  );
};

export default AdminProduct;
